import { Box } from '@mui/material';

import React, { ReactNode } from 'react';

export interface FooterWhiteBackgroundWrapperProps {
  children: ReactNode;
}

export default function FooterWhiteBackgroundWrapper({
  children,
}: FooterWhiteBackgroundWrapperProps) {
  return (
    <Box
      sx={{
        '& > footer': {
          backgroundColor: 'care.white',
        },
      }}>
      {children}
    </Box>
  );
}
